/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Detail_PathInputs */

const en_audit_detail_path = /** @type {(inputs: Audit_Detail_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Path`)
};

const pt_br2_audit_detail_path = /** @type {(inputs: Audit_Detail_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caminho`)
};

/**
* | output |
* | --- |
* | "Path" |
*
* @param {Audit_Detail_PathInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_detail_path = /** @type {((inputs?: Audit_Detail_PathInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Detail_PathInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_detail_path(inputs)
	return pt_br2_audit_detail_path(inputs)
});